// src/config.js

// import { c } from "vite/dist/node/types.d-aGj9QkWt";

// Description: Theme and Environment configuration file.
// Documentation: https://v4.mui.com/customization/default-theme/

// ===========================|| ENVIRONMENT ACCESS ||=========================== //
export const VERSION = import.meta.env.VITE_APP_VERSION;
export const API_URL = import.meta.env.VITE_APP_API_URL; // https://mock-data-api-nextjs.vercel.app/
export const DJANGO_API_URL = import.meta.env.VITE_APP_DJANGO_API_URL;

// ==============================|| CLERK CONFIGURATION ||============================== //
export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
export const CLERK_FRONTEND_API = import.meta.env.VITE_CLERK_FRONTEND_API; // https://frontend-api.clerk.dev
export const CLERK_BACKEND_API = import.meta.env.VITE_CLERK_BACKEND_API; // https://api.clerk.dev
export const CLERK_FRONTEND_URL = import.meta.env.VITE_CLERK_FRONTEND_URL; // hopeful-turtle-43.clerk.accounts.dev
export const CLERK_BACKEND_URL = import.meta.env.VITE_CLERK_BACKEND_URL; // api.clerk.com

// // Debugging: Log Clerk URLs
// console.log('CLERK_PUBLISHABLE_KEY:', CLERK_PUBLISHABLE_KEY);   
// console.log('CLERK_FRONTEND_API:', CLERK_FRONTEND_API);
// console.log('CLERK_BACKEND_API:', CLERK_BACKEND_API);
// console.log('CLERK_FRONTEND_URL:', CLERK_FRONTEND_URL);
// console.log('CLERK_BACKEND_URL:', CLERK_BACKEND_URL);

// // Debugging: Log API URLs
// console.log('API_URL:', API_URL);
// console.log('DJANGO_API_URL:', DJANGO_API_URL);
// console.log('CLERK_FRONTEND_API:', CLERK_FRONTEND_API);


// ==============================|| THEME CONSTANTS ||============================== //
export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/dashboard';
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export let SimpleLayoutType;

(function (SimpleLayoutType) {
  SimpleLayoutType['SIMPLE'] = 'simple';
  SimpleLayoutType['LANDING'] = 'landing';
})(SimpleLayoutType || (SimpleLayoutType = {}));

export let ThemeMode;

(function (ThemeMode) {
  ThemeMode['LIGHT'] = 'light';
  ThemeMode['DARK'] = 'dark';
})(ThemeMode || (ThemeMode = {}));

export let MenuOrientation;

(function (MenuOrientation) {
  MenuOrientation['VERTICAL'] = 'vertical';
  MenuOrientation['HORIZONTAL'] = 'horizontal';
})(MenuOrientation || (MenuOrientation = {}));

export let ThemeDirection;

(function (ThemeDirection) {
  ThemeDirection['LTR'] = 'ltr';
  ThemeDirection['RTL'] = 'rtl';
})(ThemeDirection || (ThemeDirection = {}));

export let NavActionType;

(function (NavActionType) {
  NavActionType['FUNCTION'] = 'function';
  NavActionType['LINK'] = 'link';
})(NavActionType || (NavActionType = {}));

export let DropzopType;

(function (DropzopType) {
  DropzopType['DEFAULT'] = 'default';
  DropzopType['STANDARD'] = 'standard';
})(DropzopType || (DropzopType = {}));

// ==============================|| THEME CONFIG ||============================== //

const config = {
  fontFamily: `'Roboto', sans-serif`,
  i18n: 'en',
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR,
};

export default config;